import React, { useState, useEffect, Fragment } from "react";
import { motion } from "framer-motion"; 
import Header from "../comps/header";
import Banner from "../comps/banner";
import SectionPrices from "../comps/sectionPrices";
import Loader from "../comps/loader";
import Footer from "../comps/footer";

function Home() {
  const [loading, setLoading] = useState(true);

  return (
    <Fragment>
      {loading ? (
        <Loader onLoadComplete={() => setLoading(false)} />
      ) : (
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.8, ease: "easeOut" }} 
        >
          <div className="top-banner-publicity">
            <div className="marquee-container">
              <h3>🚀 Potencia tu negocio con una web profesional y software a medida 📩 Contáctanos hoy.</h3>
              <h3>🚀 Potencia tu negocio con una web profesional y software a medida 📩 Contáctanos hoy.</h3>
              <h3>🚀 Potencia tu negocio con una web profesional y software a medida 📩 Contáctanos hoy.</h3>
              <h3>🚀 Potencia tu negocio con una web profesional y software a medida 📩 Contáctanos hoy.</h3>
            </div>
          </div>

          <Header />
          <section><Banner /></section>
          <section className="container section-text-prices">
            <h2 className="text-sec-text-prices">Nuestras membresías mensuales</h2>
            <p className="textsub-sec-text-prices">Membresías para el sector de tecnología y automatización de tu marca</p>
          </section>
          <section className="section-prices"><SectionPrices /></section>
          <Footer />
        </motion.div>
      )}
    </Fragment>
  );
}

export default Home;
